import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'neo-main-header-reservar',
  templateUrl: './main-header-reservar.component.html',
  styleUrls: ['./main-header-reservar.component.scss']
})
export class MainHeaderReservarComponent implements OnInit {

  @Input() url: string;
  @Input() target = false;
  @Input() iconoClase = '';
  @Input() icono: string;
  @Input() label = 'Reserva ahora';
  @Input() pathDestino = '/reservar';

  constructor(
    private router: Router,
  ) { }

  ngOnInit(): void {
  }

  clickLink() {
    this.router.navigate([this.pathDestino]);
  }
}
